module.exports = __webpack_public_path__ + "6f2f6c056047c5090e93222d647eac6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bmi.png
// module id = 287
// module chunks = 1